module.exports = __webpack_public_path__ + "static/img/iconfont.10e3951.svg";


//////////////////
// WEBPACK FOOTER
// ./src/openSurvey/theme/fonts/iconfont.svg
// module id = jKyn
// module chunks = 1